import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import {
  DomainsSearchingForm,
  useGetAllDomainsQuery,
  useUpdateDomainConfigurationStatus,
  useUpdateDomainDeployStatus,
  useUpdateDomainHealthStatus,
} from '@/modules/Domains';

import { DomainsListView } from './DomainsListView';

export const DomainsListContainer: FC = memo(() => {
  const { pageParam, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: domainsListData,
    error: domainsListError,
    isLoading: isDomainsListLoading,
    isFetching: isDomainsListFetching,
    isError: isDomainsListError,
  } = useGetAllDomainsQuery({ page: pageParam }, search)();

  useUpdateDomainHealthStatus({ pageParam: { page: pageParam } });

  useUpdateDomainDeployStatus({
    pageParam: { page: pageParam },
    domainName: null,
  });

  useUpdateDomainConfigurationStatus({
    pageParam: { page: pageParam },
  });

  return (
    <FallbackedLayout
      isLoading={isDomainsListLoading}
      error={domainsListError}
      isError={isDomainsListError}
      data={domainsListData}
    >
      {(domainsList): ReactElement => (
        <>
          <DomainsSearchingForm search={search} handleSubmitSearch={setSearch} />
          <DomainsListView
            currentPage={pageParam}
            domainsListItems={domainsList.items}
            domainsListTotalItems={domainsList.meta.totalItems}
            domainsListItemsPerPage={domainsList.meta.itemsPerPage}
            isLoading={isDomainsListFetching}
            handleChangePage={handleChangePage}
          />
        </>
      )}
    </FallbackedLayout>
  );
});
